import moment from 'moment'
import { ModuleNames } from '../../../constants/componentNames.constants'
import { generateBlogPostSlug } from '../../../utils/blog.utils'
import { isResourceCategory } from '../../../utils/functions.utils'
import { getMicrocopyData } from '../../../utils/microcopy.utils'

export const getResourceData = (resource: any) => {
  if (!resource) return {}

  let category = ''
  let number = -1
  let image = ''
  let imageAlt = ''
  let title = ''

  if (resource.__typename === ModuleNames.PAGE_RESOURCE_DEMO) {
    image = resource.spotlight?.video?.image?.file?.url
    imageAlt = resource.spotlight?.video?.altText
    title = resource.hero?.headline
  } else if (resource.__typename === ModuleNames.PAGE_BLOG_POST) {
    image = resource.image?.image?.file?.url
    imageAlt = resource.image?.altText
    title = resource.h1Title
  } else {
    image = resource.image?.image?.file?.url
    imageAlt = resource.image?.altText
    title = resource.title
  }

  let date = resource.date || ''
  if (resource.category) {
    if (resource.category.title) category = resource.category.title
    if (resource.category.number) number = resource.category.number
  }

  let microcopy = resource.microcopy ? resource.microcopy : undefined
  let url1 = ''

  if (resource.__typename === ModuleNames.TEASER) {
    if (resource.url1) url1 = resource.url1
  } else if (resource.slug) {
    if (resource.__typename === ModuleNames.PAGE_BLOG_POST) {
      url1 = generateBlogPostSlug({
        slug: resource.slug,
        blogCategoryName: resource?.category?.name,
        pageLocale: resource?.entryLocale,
      })
    } else url1 = resource.slug.charAt(0) === '/' ? resource.slug : `/${resource.slug}`
  }

  let cta: any
  if (microcopy && number != -1) cta = getMicrocopyData(microcopy, number, 'primary', 'text')

  let convertedDate
  if (date) {
    convertedDate = new Date(date)
    date = moment(convertedDate).format('MMMM D, YYYY')
  }

  let when, ctaText
  if (
    (isResourceCategory('Webinar', number) || isResourceCategory('Events', number)) &&
    cta &&
    cta.length >= 2 &&
    convertedDate
  ) {
    let now = new Date()
    when = convertedDate >= now ? 'before' : 'after'
    if (cta[0].key && cta[0].key.includes(when)) ctaText = cta[0].value
    else if (cta[1].key && cta[1].key.includes(when)) ctaText = cta[1].value
  }

  //* If not webinar, get the first cta text value
  if (!ctaText && cta && cta[0] && cta[0].value) ctaText = cta[0].value
  return { category, number, title, ctaText, url1, image, imageAlt }
}
